export enum RequestStatus {
  LOADING,
  SUCCESS,
  ERROR,
}
